import { useAuth } from './auth/AuthProvider'
import { createBrowserBridge } from './bridge/browserBridge'
import { AppLayout } from './components/AppLayout'
import { InstallPrompt } from './components/InstallPrompt'
import { AuthFlow } from './screens/auth/AuthFlow'
import { LoadingScreen } from './screens/LoadingScreen'
import { AppShell } from './shells/AppShell'

const bridge = createBrowserBridge()

const App = () => {
  const { session, loading, logout } = useAuth()

  const content = loading ? (
    <LoadingScreen />
  ) : session ? (
    <AppLayout bridge={bridge} session={session} onLogout={logout} />
  ) : (
    <AuthFlow />
  )

  return (
    <AppShell>
      {content}
      <InstallPrompt />
    </AppShell>
  )
}

export default App
